// Karaoke Room Page
'use client';

import KaraokePage from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke';

export default function KaraokeRoom() {
  return <KaraokePage />;
}
